import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { supportedLanguages } from '@/i18n/options';
import { translations } from '@/i18n/translations';

i18n
  .use(initReactI18next) 
  .init({
    resources: translations,
    supportedLngs: supportedLanguages, 
    lng: 'en',
    fallbackLng: 'en', 
    debug: false, 
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },
  });

export default i18n;
